import FormContent from './FormContent';

export default FormContent;
